import each from 'lodash/each';

const Types = {};
const Decorations = {};
const Validators = {};
const Conditions = {};

export function registerField(type, component) {
  Types[type] = component;
}

export function getField(type) {
  return Types[type];
}

export function registerDecoration(type, component) {
  Decorations[type] = component;
}

export function getDecoration(type) {
  return Decorations[type];
}

export function registerValidator(validator, method) {
  Validators[validator] = method;
}

export function getValidator(validator) {
  return Validators[validator];
}

export function registerCondition(condition, method) {
  Conditions[condition] = method;
}

export function testValidators(fieldKey, schema, model, condition) {
  let hasError = false;
  let error = null;
  let isRequired = false;

  each(schema.validators, (validatorItem) => {
    // This makes sure we display the first error
    if (hasError) return;
    if (!Validators[validatorItem.type]) return console.warn(`Validator: ${validatorItem.type} has not been registered`);
    const testedValidator = Validators[validatorItem.type]({
      condition,
      fieldKey,
      fieldValue: model[fieldKey],
      model,
      schema,
      validator: validatorItem,
    });
    ({ hasError, error, isRequired } = testedValidator);
  });

  return {
    isRequired,
    error,
    hasError,
  };
}

export function testConditions(fieldKey, schema, model) {
  let hasCondition = false;
  let condition = null;
  let shouldHideField = false;
  let setValue;

  each(schema.conditions, (conditionItem) => {
    // This makes sure we display the first condition
    if (hasCondition) return;
    if (!Conditions[conditionItem.type]) return console.warn(`Condition: ${conditionItem.type} has not been registered`);
    const testedCondition = Conditions[conditionItem.type]({
      fieldKey,
      fieldValue: model[fieldKey],
      model,
      schema,
      condition: conditionItem,
    });
    ({ hasCondition, condition } = testedCondition);
    shouldHideField = (hasCondition && conditionItem.shouldHideField);
    setValue = conditionItem.setValue;
  });

  return {
    hasCondition,
    condition,
    shouldHideField,
    setValue,
  };
}
